










































































import {
    Component, Inject, Mixins, Model, Prop, Vue,
} from 'vue-property-decorator';
import { concat, filter } from 'lodash';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { ProductTemplateContent } from '@/assets/interface/Product';
import { Validator } from 'vee-validate';

@Component
export default class ODynamictextfield extends Mixins(IsMobileMixin) {
    @Prop() public templateModel!: ProductTemplateContent;

    @Prop() public templateModelList!: ProductTemplateContent[];

    // this is for veevalidate
    @Inject('$validator') public $validator!: Validator;

    @Prop({ default: '' }) public validateTitle!: any;

    @Prop({ default: '' }) public validateContent!: any;

    get field() {
        return `field${this.templateModel.id}`;
    }

    get fieldName() {
        return `fieldName${this.templateModel.id}`;
    }

    get joinErrors() {
        return concat(this.errors.first(this.fieldName),
            this.errors.first(this.field));
    }

    get errorKey() {
        return `errorMessages-${this.templateModel.id}`;
    }

    get duplicateFieldName() {
        if (this.templateModel.title !== '') {
            const filtered = filter(
                this.templateModelList,
                (template: ProductTemplateContent) => template.title === this.templateModel.title,
            );
            return filtered.length > 1;
        }
        return false;
    }

    get showErrorMessages() {
        if (this.duplicateFieldName) {
            return true;
        }
        if (this.joinErrors[0] === 'no duplicate field name') {
            return false;
        }
        return this.errors.has(this.field)
                    || this.errors.has(this.fieldName);
    }

    get errorMessages() {
        let code = '';
        let errorMessages = '';

        const fieldNameErrorMessage = this.errors.first(this.fieldName);
        if (fieldNameErrorMessage === 'the field is required') {
            code = 'required';
            errorMessages += 'the field name';
        } else if (fieldNameErrorMessage === 'no duplicate field name') {
            errorMessages += `"${this.templateModel.title}" is duplicated, please use different field name`;
        } else if (fieldNameErrorMessage) {
            errorMessages += fieldNameErrorMessage;
        }

        const fieldErrorMessage = this.errors.first(this.field);
        if (fieldErrorMessage === 'the field is required') {
            code = 'required';
            if (errorMessages.length !== 0) {
                errorMessages += ' and ';
            }
            errorMessages += 'the field content';
        } else if (fieldErrorMessage) {
            if (errorMessages.length !== 0) {
                errorMessages += ' and ';
            }
            errorMessages += fieldNameErrorMessage;
        }

        if (code === 'required') {
            errorMessages += ' can not be empty';
        }

        return errorMessages;
    }
}
